import { PersonDataComponent } from './PersonData';
import { connect } from 'react-redux';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state: any) => ({});
const mapDispatchToProps = {};

export const PersonDataStep = connect(mapStateToProps, mapDispatchToProps)(PersonDataComponent);
